module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Medium.a0172bf.eot";